module.exports = __webpack_public_path__ + "img/_13.f599984f.png";